export default function (func, selector, shift) {
    if (selector && 'IntersectionObserver' in window) {
        let rootMargin = shift ? shift : '480px';
        let target = document.getElementById(selector);
        let io = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    func();
                    io.unobserve(target)
                }
            },
            {
                rootMargin: rootMargin,
            }
        );
        io.observe(target);
    } else {
        window.addEventListener('load', function () {
            setTimeout(func, 2500);
        });
    }
};